import { render, staticRenderFns } from "./DpeGes.vue?vue&type=template&id=50482f1e&"
import script from "./DpeGes.vue?vue&type=script&lang=js&"
export * from "./DpeGes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports